import React, { useContext } from 'react'
import Loader from './Loader'
import '../style/HomeScreen.scss'
import { LanguageContext } from '../context/LanguageContext'
import { useSelector } from 'react-redux'


export default function HomeScreen() {
    const { strings } = useContext(LanguageContext)
    const { isLoggedIn } = useSelector(state=> state.auth)
    const { isLoading } = useSelector(state=>state.languageChange)
        
    return (
        isLoggedIn ? <div className="home-screen ">
            {/* Added Fallback strings for showAndGoText */}
            <div className="first-line">{isLoading ? 'Mobile Checkout'  : strings.showAndGoText}</div>
            <div className="mobile-checkout"></div>
            <Loader languageFetched={!isLoading}/>
        </div> : null

    )
}
